import React, { Component } from 'react';
import { Button, Col, Row, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import {
  queryExportPayablePending,
  queryPayableDetailStatistics,
  queryPayablePending,
} from '@api/incubator/payable';
import util from '@util/index';
import ReactDOM from 'react-dom';
import ChangeType from './ChangeType';

class TablePending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      statis: {},
    };
  }

  componentDidMount() {
    const { billTab, condition } = this.props;
    this.type = billTab.pendingType || '-1';
    this.current = billTab.pendingPage || 1;
    this.pageSize = billTab.pendingPageSize || 10;
    this.condition = condition;
    this.getPayablePending();
    this.getPayableDetailStatistics();

    if (this.table) {
      const tableCon = ReactDOM.findDOMNode(this.table);
      console.log('tableCon:', tableCon);
      const table = tableCon.querySelector('table');
      console.log('table:', table);
      table.setAttribute('id', 'table-to-xls');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(key => nextProps.condition[key] !== this.condition[key])
    ) {
      this.condition = nextProps.condition;
      this.getPayablePending();
      this.getPayableDetailStatistics();
    }
  }

  onChange = e => {
    this.type = e.target.value;
    this.current = 1;
    this.getPayablePending();
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getPayablePending();
  };

  getPayableDetailStatistics = () => {
    queryPayableDetailStatistics({
      tab: 'PENDING',
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          statis: res.data,
        });
      }
    });
  };

  getPayablePending = () => {
    this.setState({
      isLoading: true,
    });
    const { pageSize } = this;
    queryPayablePending({
      ...this.condition,
      type: this.type >= 0 ? this.type : '',
      limit: pageSize,
      start: this.current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.props.onPageChange(this.type, this.current, pageSize);
        this.setState({
          isLoading: false,
          dataSource: {
            list: res.data,
            pagination: {
              pageSize,
              total: res.totalSize,
              current: this.current,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: [10, 20, 50, 100],
            },
          },
        });
      }
    });
  };

  columns = () => {
    const { type } = this.props;
    return [
      {
        title: '账单编号',
        dataIndex: 'no',
        width: 160,
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '企业名称',
        dataIndex: 'custom',
        width: 120,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        width: 220,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        render: (text, record) => <span>{type[text]}</span>,
        width: 100,
      },
      {
        title: '待收款',
        dataIndex: 'price',
        width: 120,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      },
      {
        title: '已收款',
        dataIndex: 'confirm',
        width: 120,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      },
      {
        title: '款项状态',
        dataIndex: 'payStatus',
        width: 100,
        render: (text, record) => {
          let statusFont = '';
          if (record.price > 0) {
            if (record.confirm > 0) {
              statusFont = '部分匹配';
            } else {
              statusFont = '没有匹配';
            }
          } else {
            statusFont = '完成匹配';
          }
          return <span>{statusFont}</span>;
        },
      },
      {
        title: '应收日期',
        dataIndex: 'date',
        width: 200,
        render: (text, record) => {
          const day = record.interval ? Math.ceil(Math.floor(record.interval) / 1440) : 0;
          const flag = day > 0 ? '剩余' : '逾期';
          return (
            <span>
              {text ? moment.unix(record.date / 1000).format('YYYY-MM-DD') : ''}({day ? flag : ''}
              {day ? `${day}天` : ''})
            </span>
          );
        },
      },
    ];
  };

  export = async e => {
    queryExportPayablePending({
      ...this.condition,
      type: this.type >= 0 ? this.type : '',
    });
  };

  render() {
    const {
      dataSource: { list, pagination },
      statis,
      isLoading,
    } = this.state;
    const { billTab } = this.props;
    return (
      <div>
        <Row>
          <Col span={20}>
            <div style={{ marginBottom: '16px' }}>
              <ChangeType
                statis={statis}
                onChange={this.onChange}
                defaultValue={billTab.pendingType || '-1'}
                isLoading={isLoading}
              />
            </div>
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            <Button
              icon="export"
              style={{ marginBottom: 15, marginRight: 8 }}
              onClick={this.export}
            >
              导出
            </Button>
          </Col>
        </Row>
        <Table
          ref={ref => {
            this.table = ref;
          }}
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          rowKey="uuid"
          onChange={this.onTableChange}
          loading={isLoading}
          scroll={{ x: true, y: false, scrollToFirstRowOnChange: true }}
        />
      </div>
    );
  }
}

export default TablePending;



// WEBPACK FOOTER //
// ./src/components/incubator/bill/TablePending.js